// extracted by mini-css-extract-plugin
export default {"device-info-panel":"sEEa","deviceInfoPanel":"sEEa"};